import { Injectable } from '@angular/core';
import { NavigationTarget } from '../../navigation-target';
import { ShellRoutes } from '../../portal-routes';
import { LandingContext, LandingRule } from '../landing-rule';

/** A user without organizations cannot use the portal: he lands on the Shell "no organizations connected" page. */
@Injectable({ providedIn: 'root' })
export class NoOrganizationsLandingRule implements LandingRule {
  resolve({ organizations }: LandingContext): NavigationTarget | null {
    return organizations.length === 0 ? NavigationTarget.internal(ShellRoutes.noOrganizationsConnected) : null;
  }
}
